import { useCallback, useEffect, useState } from 'react'

import Page from '../../components/Page'
import NewLawsCard from './NewLawsCard'
import { useAdmins } from '../../api/admins'
import { useCards } from '../../api/cards'
import EmptyList from '../../components/EmptyList'

const NewLawsPage = () => {
  const { admins } = useAdmins()
  const { isLoading, cards, updateCard, saveCard } = useCards()

  const handleChange = useCallback((id: number, value: any, name: string) => {
    updateCard(id, {
      [name]: value,
    })
  }, [])

  const handleLawChange = (id: number, value: string, lawId: number) => {
    const card = cards.find((card) => card.id === id)
    if (card) {
      const law = card.newLaws.find((law) => law.publishedLawId === lawId)
      if (law) {
        law['status'] = value
        updateCard(id, {
          newLaws: card.newLaws,
        })
      }
    }
  }

  return (
    <Page>
      <div>
        {!isLoading ? (
          cards.length > 0 ? (
            <ul className="flex flex-col items-center">
              {cards.map((card) => (
                <NewLawsCard
                  card={card}
                  admins={admins}
                  onChange={handleChange}
                  onLawChange={handleLawChange}
                  onSave={saveCard}
                />
              ))}
            </ul>
          ) : (
            <div className="mx-auto w-5/6">
              <EmptyList />
            </div>
          )
        ) : (
          'Loading...'
        )}
      </div>
    </Page>
  )
}

export default NewLawsPage
